export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.13-0957.50",
  commitId: "883388b8e7d0066d862208543bc7b9237364095c",
  commitTime: "2026-05-13T09:57:50.000Z",
});
